import { render, staticRenderFns } from "./resultView.vue?vue&type=template&id=fbf1e3a8&scoped=true"
import script from "./resultView.vue?vue&type=script&lang=js"
export * from "./resultView.vue?vue&type=script&lang=js"
import style0 from "./resultView.vue?vue&type=style&index=0&id=fbf1e3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf1e3a8",
  null
  
)

export default component.exports